import { mapActions } from 'vuex';
import { AUTH_REQUEST, AUTH_LOGOUT } from '../actions/auth';

export default mapActions('auth', {
  logIn: AUTH_REQUEST,
  logOut: AUTH_LOGOUT,
});
